const KEY = "hp_player_prefs";

/** Device settings of the player; not tied to the listener or the account */
export interface PlayerPrefs {
    rate: number;
    volume: number;
    muted: boolean;
}

export const readPlayerPrefs = (): Partial<PlayerPrefs> => {
    try {
        const parsed: unknown = JSON.parse(localStorage.getItem(KEY) ?? "null");
        if (!parsed || typeof parsed !== "object") return {};

        const { rate, volume, muted } = parsed as Record<string, unknown>;
        return {
            ...(typeof rate === "number" && rate >= 0.25 && rate <= 4 ? { rate } : {}),
            ...(typeof volume === "number" && volume >= 0 && volume <= 1 ? { volume } : {}),
            ...(typeof muted === "boolean" ? { muted } : {}),
        };
    } catch {
        return {};
    }
};

export const writePlayerPrefs = (prefs: PlayerPrefs) => {
    try {
        localStorage.setItem(KEY, JSON.stringify(prefs));
    } catch {
        // Blocked or full: the settings then only last until the page is closed
    }
};

const CLOSED_KEY = "hp_player_closed_at";

/** When the listener last closed the player, so that it stays closed after a reload (milliseconds; 0 if never) */
export const readPlayerClosedAt = (): number => {
    try {
        const value = Number(localStorage.getItem(CLOSED_KEY));
        return Number.isFinite(value) ? value : 0;
    } catch {
        return 0;
    }
};

export const writePlayerClosedAt = (time: number) => {
    try {
        localStorage.setItem(CLOSED_KEY, String(time));
    } catch {
        // Blocked or full: the player then comes back after a reload
    }
};
